import {Boot} from '@/project'
import VueGtm from 'vue-gtm'

const boot: Boot = ({Vue, router}) => {
  if(process.env.VUE_APP_GTM_ID) {
    Vue.use(VueGtm, {
      id: process.env.VUE_APP_GTM_ID,
      enabled: true,
      debug: false,
      vueRouter: router,
    })
  }
}

export default boot
